import { useEffect, useRef } from 'react';
import { trackView, ViewType } from '../services/viewTracking';

interface UseViewTrackingOptions {
  viewType: ViewType;
  resourceId?: string;
  enabled?: boolean;
}

export const useViewTracking = ({ viewType, resourceId, enabled = true }: UseViewTrackingOptions) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!enabled || hasTracked.current) return;

    // Track view after a short delay to ensure page is loaded
    const timer = setTimeout(() => {
      trackView(viewType, resourceId)
        .then(() => {
          hasTracked.current = true;
        })
        .catch((error) => {
          // Silently fail - don't interrupt user experience
          console.warn('View tracking failed:', error);
        });
    }, 1000);

    return () => clearTimeout(timer);
  }, [viewType, resourceId, enabled]);
};

